define('bindingHandlers/isEventTargetWithin',[
    'lib/knockout',
    'jquery'
], function (ko, $) {
    'use strict';

    var EVENT_NAMESPACE = ".isEventTargetWithin-evt";
    var bindingCount = 0;

    /**
     * A binding handler that checks if the specified event occurs within the specified container. If not, it calls with given function with the given parameters.
     *
     * # Required Arguments
     *
     * @param {String} event - The event to listen for
     * @param {String} container - The class name or id of the container to check and see if the event occured within
     * @param {Function} func - The function to be called if the event was NOT triggered within the container
     * @param {Array} funcParams - The parameters to be passed to the function when it is called
     *
     * # Example
     *
     *      <div data-bind="
     *          isEventTargetWithin: {
     *              event: 'click',
     *              container: '.class-name',
     *              func: functionName,
     *              funcParams: [ param1, param2, param3 ]
     *          }
     *      ">
     *
     */
    ko.bindingHandlers.isEventTargetWithin = {
        init: function(element, valueAccessor) {
            bindingCount++;

            var params = valueAccessor();

            if(bindingCount <= 1) {
                $(document).on(params.event + EVENT_NAMESPACE, function(e) {
                    // Check if the event target is not within the container AND in the DOM (deals with a specific case where the target has already been removed when this triggers)
                    if($(e.target).closest(params.container).length <= 0 && $.contains(document, e.target)) {
                        params.func.apply(null, params.funcParams);
                    }
                });
            }

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                bindingCount--;
                if(bindingCount <= 0) {
                    $(document).off(EVENT_NAMESPACE);
                }
            });
        }
    };
});

